import { EditableText } from '@smartfire/components';
import { useInspectorControl, useEditor, smartProps, defineBlock } from '@smartfire/js-block-engine';
import React from 'react';

import style from './block.module.scss';

const InspectorLazy = React.lazy(() => import('./Inspector'));

function Block({ title, text, anchorName }) {
    useInspectorControl(InspectorLazy, []);
    const { isEditing } = useEditor();

    return (
        <div className={style.block}>
            <div className={style.anchor} id={anchorName} />
            <div className={style.content}>
                {(isEditing || title) && (
                    <EditableText tagName="h2" placeholder="ajouter un sous-titre" smartProp="title" />
                )}
                {(isEditing || text) && <EditableText tagName="p" placeholder="ajouter un texte" smartProp="text" />}
            </div>
        </div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        anchorName: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Titre ancre',
        icon: 'align-center',
    },
});
